import { Component, input } from '@angular/core';
import { OpportunityAssociationPanelComponent } from '../opportunity-associations-panel/opportunity-association-panel.component';
import { ObjectType } from '../../../tokens-and-interfaces';

@Component({
  selector: 'crm-custom-object-to-opportunity-associations-panel',
  imports: [OpportunityAssociationPanelComponent],
  templateUrl: './custom-object-to-opportunity-associations-panel.component.html',
  styleUrls: ['../../../shared-styles/association-panel-shared.scss'],
})
export class CustomObjectToOpportunityAssociationsPanelComponent {
  id = input<string>('');
  name = input<string>('');
  objectType = input<ObjectType>('CustomObject');
}
